import Cookies from "js-cookie";
import { CookieDetailV3 } from "./types";

export function getCookieConsent(): CookieDetailV3 | undefined {
  const cookieConsent = Cookies.get("cookie_consent_v3");

  if (cookieConsent) {
    try {
      return JSON.parse(cookieConsent);
    } catch (e) {
      return undefined;
    }
  }

  return undefined;
}
